import React, { FC } from 'react';
import { Typography, Button, Box } from '@mui/material';
import StyledBox from 'views/rebranded-module/blogs-module/BlogsViewV2/components/HeaderSection/HeaderSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { RiArrowLeftLine } from 'react-icons/ri';
interface HeaderProps {
  isSearchResultVariant?: string;
}
const HeaderSection: FC<HeaderProps> = (props) => {
  const { isSearchResultVariant } = props;
  const content = useContent('BlogsPage');

  return (
    <StyledBox>
      {isSearchResultVariant && (
        <Box className="HSBackButtonWrapper">
          <Button
            startIcon={<RiArrowLeftLine className="HSBackIcon" />}
            variant="text"
            color="secondary"
            component={NavigatorLink}
            className="HSBackButton"
            href={PATHS.motorcycleTouring.index()}>
            {content.backToMainBlogBtnText}
          </Button>
        </Box>
      )}
      <Typography variant="h7" component="h2" mb={1}>
        {content.title}
      </Typography>
      <Typography variant="h1" component="h1" mb={2}>
        {content.heading}
      </Typography>
      <Typography variant="body1" component="p" className="HSSubtitle">
        {content.subTitle}
      </Typography>
    </StyledBox>
  );
};

export { HeaderSection };
